<div class="container">
  <div class="content">

    <app-stepper-header
      title="Hero Report"
      i18n-title="Hero report title@@heroReportTitle"
      [steps]="steps"
      [step]="step">
    </app-stepper-header>

    <div class="panel-container">
      <div [ngSwitch]="step" class="step-container">
        <app-incident-report-step1
          *ngSwitchCase="0"
          [formGroup]="initialForm"
          [heroReport]="heroReport"
        ></app-incident-report-step1>

        <app-incident-report-step2
          *ngSwitchCase="1"
          [formGroup]="actionForm"
          [deleteable]="true"
        ></app-incident-report-step2>

      </div>
      <div class="stepper-actions">

        <button
          pButton
          (click)="goBack()"
          class="p-button-text"
          i18n="Cancel button@@cancelButton">
          Cancel
        </button>

        <button
          pButton
          *ngIf="step < stepValid.length - 1"
          (click)="nextStep()"
          class="p-button-primary"
          i18n="Next button@@nextButton">
          Next
        </button>

        <button
          pButton
          *ngIf="step === stepValid.length - 1"
          (click)="submit()"
          class="p-button-primary"
          i18n="Submit button@@submitButton">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>